import React from "react";
import { default as WTableFooter } from "@mui/material/TableFooter";

function TableFooter(props) {
  return <WTableFooter {...props} />;
}

export default TableFooter;
